'use client';
import {
  CatHeading,
  CatTooltip,
  CatTextPassage
} from 'components/blocks-components';
import { useCallback } from 'react';
import { Conditional, CustomStyledLabel } from '@cat-ecom/pcc-components';
import { SelectedEquipmentHeadingProps } from '../../../types';
import cx from 'classnames';

export const SelectedEquipmentHeading = ({
  children,
  showTooltip = true,
  className,
  tooltipSize = 'sm',
  ...headingProps
}: Readonly<SelectedEquipmentHeadingProps>) => {
  const getLabel = useCallback(() => {
    return (
      <CatHeading slot="trigger" {...headingProps}>
        <CustomStyledLabel
          className={cx({ 'text-truncate d-block': showTooltip })}
        >
          {children}
        </CustomStyledLabel>
      </CatHeading>
    );
  }, [children, headingProps, showTooltip]);
  return (
    <div className={className}>
      <Conditional test={showTooltip} fallback={getLabel()}>
        <CatTooltip position="auto">
          {getLabel()}
          <CatTextPassage size={tooltipSize}>{children}</CatTextPassage>
        </CatTooltip>
      </Conditional>
    </div>
  );
};
